import React from "react";
import { motion } from "framer-motion";

const ECO_OPTS = [
  { id: "apple",  label: "Apple Home",  hint: "HomeKit / Matter",  icon: "🍏" },
  { id: "google", label: "Google Home", hint: "Google Home / Matter", icon: "📢" },
  { id: "alexa",  label: "Amazon Alexa", hint: "Alexa / Zigbee‑Bridge", icon: "🗣" },
  { id: "mixed",  label: "Vegyes / nincs preferencia", hint: "Rugalmas kompatibilitás", icon: "🌐" },
];

export default function EcosystemStep({ value, onChange, onNext }) {
  return (
    <motion.div
      className="bg-white rounded-2xl border border-gray-200 p-5"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      <h2 className="text-2xl font-semibold mb-2">Melyik ökoszisztémát szeretnéd használni?</h2>
      <p className="text-gray-600 mb-4 text-sm">
        Ez nem kötelező választás, csak segít a legjobb központot és termékeket ajánlani.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {ECO_OPTS.map((opt, i) => {
          const active = value === opt.id;
          return (
            <motion.button
              key={opt.id}
              type="button"
              onClick={() => onChange(opt.id)}
              className={`text-left p-4 rounded-2xl border transition ${
                active ? "border-blue-500 ring-2 ring-blue-200" : "border-gray-200 hover:border-gray-300"
              }`}
              initial={{ opacity: 0, y: 6 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04, duration: 0.2 }}
            >
              <div className="text-3xl">{opt.icon}</div>
              <div className="mt-2 font-semibold">{opt.label}</div>
              <div className="text-sm text-gray-600">{opt.hint}</div>
              {active && <div className="mt-2 text-xs text-blue-600">Kiválasztva</div>}
            </motion.button>
          );
        })}
      </div>

      <div className="flex justify-end mt-6">
        <button
          className="bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700 disabled:opacity-50"
          onClick={onNext}
          disabled={!value}
        >
          Tovább
        </button>
      </div>
    </motion.div>
  );
}
